import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { AVATAR_SIZES } from '@usepepper/ui/atoms/avatar';
import { createStyles } from '@/contexts/theme-context';
import { LIST_ITEM_MARGIN } from '@/components/history-list-item';
import { View } from 'react-native';

export const ListItemSkeleton: React.FC = () => {
  const [styles] = useStyles();
  return (
    <View style={[styles.orderContainer, styles.container]}>
      <AnimatedSkeletonLoader
        borderRadius={AVATAR_SIZES.large / 2}
        height={AVATAR_SIZES.large}
        style={styles.resetMargin}
        width={AVATAR_SIZES.large}
      />
      <View style={styles.detailsContainer}>
        <View collapsable={false}>
          <AnimatedSkeletonLoader
            height={16}
            style={styles.resetMargin}
            width={80}
          />
          <AnimatedSkeletonLoader height={12} width={66} />
        </View>
        <AnimatedSkeletonLoader
          height={16}
          style={styles.resetMargin}
          width={36}
        />
      </View>
    </View>
  );
};

const useStyles = createStyles(() => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 14,
  },
  detailsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  orderContainer: {
    marginVertical: LIST_ITEM_MARGIN,
    paddingHorizontal: 16,
  },
  resetMargin: {
    marginTop: 0,
  },
}));
